<script context="module" lang="ts">
	import Header from '../Header.svelte';
	import headerBG from '$lib/img/graphics/header-bg.jpg';
</script>

<script lang="ts">
	export let title: string;
	export let transparent: boolean = false;

	let width: number;
</script>

<svelte:window bind:innerWidth={width} />

{#if width > 768}
	<div
		class="-mt-24 h-[20rem] bg-zinc-900 pt-24"
		style="background-image: url({headerBG}); background-position: center 10%; background-size: cover"
	>
		<h1 class="mt-8 text-center text-6xl text-white underline decoration-[3px]">{title}</h1>
	</div>
	<div class:bg-transparent={transparent} class:bg-white={!transparent} class:dark:bg-zinc-800={!transparent}>
		<div
			class="m-auto hidden min-h-[64rem] max-w-screen-2xl pb-16 md:block {$$restProps.class || ''}"
			style=""
		>
			<div class="md:mx-4 lg:mx-8">
				<slot />
			</div>
		</div>
	</div>
{:else}
	<div class="md:hidden">
		<Header pageTitle={title} />
		<div class="px-4">
			<slot />
		</div>
	</div>
{/if}
